import { render, staticRenderFns } from "./GrabLeak.vue?vue&type=template&id=5af22157&scoped=true&"
import script from "./GrabLeak.vue?vue&type=script&lang=js&"
export * from "./GrabLeak.vue?vue&type=script&lang=js&"
import style0 from "./GrabLeak.vue?vue&type=style&index=0&id=5af22157&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af22157",
  null
  
)

export default component.exports